import { IndustryConfig } from '../../../types'

export const aviationAerospaceConfig: IndustryConfig = {
  id: 'aviation-aerospace',
  name: 'Aviation & Aerospace',
  icon: '✈️',
  description: 'Aviation and aerospace companies focused on certification and market opportunities',
  
  businessTypes: [
    {
      id: 'aircraft-maintenance',
      name: 'Aircraft Maintenance & Repair',
      description: 'MRO services for commercial and private aircraft'
    },
    {
      id: 'aerospace-manufacturing',
      name: 'Aerospace Manufacturing',
      description: 'Manufacturing of aircraft components and systems'
    },
    {
      id: 'flight-training',
      name: 'Flight Training Services',
      description: 'Pilot training, aircraft certification, and aviation education'
    },
    {
      id: 'aviation-services',
      name: 'Aviation Support Services',
      description: 'Ground handling, logistics, and aviation consulting services'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'certification-services',
      name: 'Certification Services',
      description: 'Revenue from aircraft certification, inspection, and compliance services',
      intelligenceValue: "We'll monitor regulatory changes, certification requirements, and compliance deadlines to help you capitalize on mandatory certification opportunities and stay ahead of regulatory shifts."
    },
    {
      id: 'maintenance-contracts',
      name: 'Maintenance Contracts',
      description: 'Scheduled and unscheduled aircraft maintenance revenue',
      intelligenceValue: "We'll track aircraft fleet growth, maintenance cycle patterns, and competitor capacity to help you secure profitable long-term maintenance agreements."
    },
    {
      id: 'parts-manufacturing',
      name: 'Parts Manufacturing',
      description: 'Revenue from manufacturing and supplying aerospace components',
      intelligenceValue: "We'll monitor supply chain disruptions, OEM demand patterns, and emerging technology requirements to identify high-value manufacturing opportunities."
    },
    {
      id: 'training-education',
      name: 'Training & Education',
      description: 'Pilot training, technician certification, and aviation education services',
      intelligenceValue: "We'll track pilot shortage trends, certification requirements, and training demand to help you optimize course offerings and pricing strategies."
    }
  ],
  
  supplierCategories: [
    {
      id: 'parts-materials',
      name: 'Parts & Materials',
      suppliers: ['Boeing', 'Airbus', 'Rolls-Royce', 'GE Aviation', 'Specialized aerospace suppliers'],
      spendRanges: ['Under $25K', '$25K-$100K', '$100K-$500K', 'Over $500K']
    },
    {
      id: 'equipment-tooling',
      name: 'Equipment & Tooling',
      suppliers: ['Aerospace tooling manufacturers', 'Testing equipment suppliers', 'Hangar equipment', 'Specialized machinery', 'Calibration services'],
      spendRanges: ['Under $15K', '$15K-$75K', '$75K-$300K', 'Over $300K']
    },
    {
      id: 'certification-compliance',
      name: 'Certification & Compliance',
      suppliers: ['Regulatory consultants', 'Testing laboratories', 'Certification bodies', 'Quality assurance services', 'Documentation systems'],
      spendRanges: ['Under $10K', '$10K-$50K', '$50K-$200K', 'Over $200K']
    },
    {
      id: 'facilities-operations',
      name: 'Facilities & Operations',
      suppliers: ['Hangar leasing', 'Security services', 'Insurance providers', 'Utilities', 'Environmental compliance'],
      spendRanges: ['Under $20K', '$20K-$100K', '$100K-$500K', 'Over $500K']
    }
  ],
  
  competitiveFactors: [
    'Regulatory compliance record',
    'Certification capabilities',
    'Technical expertise',
    'Quality certifications',
    'Turnaround time',
    'Geographic coverage',
    'Equipment capabilities',
    'Safety record',
    'Industry relationships',
    'Technology innovation'
  ]
}